import type { JSX } from "react";

import logo from "#src/images/logo.header.png";

export interface Props {
  alt?: string;
  src?: string;
}

const Logo = (props: Props): JSX.Element => {
  const { alt = "Citrine Informatics", src = logo } = props;
  return <img src={src} alt={alt} />;
};

export default Logo;
